import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './OnionPage.css';
import onionLogo from '../images/onion-logo.png';
import jumbo from '../images/onion-DSA JUMBO-img.jpeg';
import vijetha from '../images/onion-vijatha-img.jpeg';

const varieties = [

  {
    name: 'DSA JUMBO',
    image: jumbo,
    description: [
      'Light red, round-shaped onions weighing 90-100 grams',
      'Ready in 90-100 days after transplanting',
      'Storage life of 5-6 months',
    ],
  },
  {
    name: 'VIJETHA',
    image: vijetha,
    description: [
      'Attractive dark to medium red, flat globe, single-centred bulbs',
      'Bulb weight: 100-125 g, with potential to reach 170-220 g depending on region',
      'Matures in about 110-120 days after transplanting',
      'Recommended for Kharif, Rabi, Late Rabi, and Summer seasons',
      'Well suited for rainy and wet conditions',
    ],
  },
];

export default function OnionPage() {
  return <ProductPatternPage title="Onion" varieties={varieties} pageClass="onion-page" heroImage={onionLogo} />;
}
